import { createClient } from "@hey-api/client-fetch";

const apiUrl = import.meta.env.VITE_API_URL;
const apiVersion = import.meta.env.VITE_API_VERSION;

function registerApiClient() {
	const client = createClient({
		baseUrl: apiUrl,
		headers: {
			"x-api-version": apiVersion
		}
	});

	client.interceptors.request.use((request, options) => {
		const accessToken = localStorage.getItem("loggedUser");
		if (accessToken) {
			request.headers.set("Authorization", `Bearer ${accessToken}`);
		}

		const profileDataJson = localStorage.getItem("profileData");
		if (profileDataJson) {
			const profileData = JSON.parse(profileDataJson);

			request.headers.set("accept-language", profileData.selectedLanguage);
		}

		return request;
	});
}

export { registerApiClient };
